import { Component, Inject, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { AuthenticationService } from '../../../../core/services/authentication.service';
import { RequestBodyService } from '../../../services';
import { CommonUtilService } from '../../../services/CommonUtil.service';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MarketoApiService } from '../../../services/api';
import { AccountAttributesEnum } from '../../../enums';
import { UserService } from '../../../../core/services/user.service';
import { getErrorMessage } from 'src/app/shared/helpers';
import { SiModalModule } from '../../si-modal';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { FilterPipeModule, OrderByPipeModule } from '../../../pipes';
import {
  DuplicateResolutionRadioGroupModule,
} from '../../ui-components/duplicate-resolution-group/duplicate-resolution-radio-group.module';
import { MatFormFieldModule } from '@angular/material/form-field';

@UntilDestroy()
@Component({
    selector: 'app-marketo',
    templateUrl: './marketo.component.html',
    styleUrls: ['./marketo.component.scss'],
    imports: [
      SiModalModule, CommonModule, FormsModule,
      MatFormFieldModule, DuplicateResolutionRadioGroupModule,
      MatButtonModule, FilterPipeModule, OrderByPipeModule, FontAwesomeModule, MatInputModule,
    ],
    standalone: true
})
export class MarketoComponent implements OnInit {
    readonly accountAttributesEnum: typeof AccountAttributesEnum = AccountAttributesEnum;
    pages = {
        loading: 0,
        leadPartition: 1,
        duplicates: 2,
        export: 3,
        exportFinished: 4,
        exportEmpty: 5,
        exportFailed: 6,
        requiresReauth: 7
    };
    contacts;
    leadPartition;
    filterLeadPartition;
    isBusy = false;
    busyLabel = 'Loading ...';
    exportError = '';
    busySublabel = '';
    duplicateResolution = 'update';
    currentPage = this.pages.duplicates;
    duplicateMatchIds;
    duplicateCount = 0;
    batchId;
    exportedContactCount = 0;
    showCloseButton = false;
    showPreviousButton = false;
    showNextButton = false;
    user: any;
    partitionName;
    showCancelButton = true;
    pagesArray = [];
    accuracyTier: string;
    accuracyTierText: string;

    constructor(
        public toastr: ToastrService,
        public requestBodyService: RequestBodyService,
        private commonUtilService: CommonUtilService,
        private authService: AuthenticationService,
        private readonly marketoApiService: MarketoApiService,
        private readonly matDialogRef: MatDialogRef<MarketoComponent>,
        private readonly userService: UserService,
        @Inject(MAT_DIALOG_DATA) public readonly data: any,
    ) {
        if (this.data['contacts']) {
            this.contacts = this.data['contacts'];
            this.accuracyTier = this.data['accuracyTier'];
            this.accuracyTierText = this.data['accuracyTierText'];
        }
    }

    ngOnInit(): void {
        this.marketoApiService.validateMapping().pipe(untilDestroyed(this)).subscribe((mappingData: { mapping?: boolean; technoLeadFields?: boolean; }) => {
            if (Object.values(mappingData).every(item => item === true)) {
                this.authService.currentUser$.subscribe(user => {
                    this.user = user;
                    if (this.user.user_meta.mktDuplicateResolution !== 'prompt') {
                        this.duplicateResolution = this.user.user_meta.mktDuplicateResolution;
                    }
                });
                if (this.user.user_meta.mktPromptForLeadPartitions === '1') {
                    this.currentPage = this.pages.leadPartition;
                    this.isBusy = true;
                    this.getLeadPartition();
                } else {
                    this.currentPage = this.pages.duplicates;
                    this.validateDuplicates();
                }
            } else {
                const sectionsInError = [];
                if (!('mapping' in mappingData) || !mappingData.mapping) {
                    sectionsInError.push('Lead Mappings');
                }
                if (this.userService.hasAccess(this.accountAttributesEnum.TECHEXPORTS)) {
                    if ('technoLeadFields' in mappingData && !mappingData.technoLeadFields) {
                        sectionsInError.push('Technographics Mappings');
                    }
                }

                if (sectionsInError.length > 0) {
                    sectionsInError.forEach(section => {
                        this.commonUtilService.showToastWithError(
                            `One or more fields in your ${section} are no longer available. Update your ${section}.`
                        );
                    });
                } else {
                    this.commonUtilService.showToastWithError('One or more fields in your integration mappings are no longer available. Update your mapping to export.');
                }
                this.matDialogRef.close();
            }
        });
    }

    getLeadPartition() {
        this.marketoApiService.getPartitions().pipe(untilDestroyed(this)).subscribe(partition => {
            this.leadPartition = partition.partitions;
            this.isBusy = false;
            this.showNextButton = true;
        });
    }
    selectLeadPartition(id) {
        if (this.partitionName !== id) {
            this.partitionName = id;
        } else {
            this.partitionName = '';
        }
    }

    next() {
        this.currentPage++;
        this.executeCurrentStep();
    }
    executeCurrentStep() {
        this.pagesArray.push(this.currentPage);
        if (this.currentPage === this.pages.export) {
            this.showPreviousButton = false;
            this.showNextButton = false;
            this.export();
        } else if (this.currentPage === this.pages.duplicates) {
            this.showCloseButton = false;
            this.showNextButton = false;
            this.showPreviousButton = false;
            if (this.duplicateMatchIds) {
                /* this.showNextButton = true;
                this.showPreviousButton = true; */
            }
            if (this.user.user_meta.mktDuplicateResolution !== 'prompt' || this.user.user_meta.mktPromptForLeadPartitions === '1') {
                this.validateDuplicates();
            } else {
                this.showNextButton = true;
                this.showPreviousButton = true;
            }
        } else if (this.currentPage === this.pages.exportFinished) {
            this.showCloseButton = true;
            this.showPreviousButton = false;
            this.showNextButton = false;
            this.showCancelButton = false;
        } else if (this.currentPage === this.pages.exportEmpty) {
            this.showNextButton = false;
            if (this.user.user_meta.mktDuplicateResolution !== 'prompt' && this.user.user_meta.mktPromptForLeadPartitions === '0') {
                this.showPreviousButton = false;
            } else {
                if (this.user.user_meta.mktPromptForLeadPartitions === '1') {
                    this.showPreviousButton = true;
                }
            }
            this.showCloseButton = true;
        } else if (this.currentPage === this.pages.leadPartition) {
            this.showNextButton = true;
            this.showPreviousButton = false;
            this.showCloseButton = false;
        }
    }

    validateDuplicates() {
        this.busyLabel = 'Validating Duplicates ...';
        this.busySublabel = 'Exporting your data, this will take just a minute...';
        this.isBusy = true;
        const matchIds = this.contacts.map((contact) => {
            if (typeof contact === 'object') {
                return contact.matchId;
            } else {
                return contact;
            }
        });
        this.marketoApiService.validateDuplicates(matchIds, this.partitionName).pipe(untilDestroyed(this)).subscribe((response) => {
            const dupeIds = [];
            let dupesCount = 0;
            this.batchId = response.batchId;
            response.contacts.forEach((item) => {
                if (item['duplicate'] === true) {
                    dupesCount++;
                    dupeIds.push(item);
                }
            });
            this.duplicateMatchIds = dupeIds;
            this.duplicateCount = dupesCount;
            if (this.duplicateMatchIds.length > 0) {
                this.showNextButton = true;
                if (this.user.user_meta.mktPromptForLeadPartitions === '1') {
                    this.showPreviousButton = true;
                }
            }
            if (dupesCount === 0) {
                this.next();
            } else {
                if (this.user.user_meta.mktDuplicateResolution !== 'prompt') {
                    this.duplicateResolution = this.user.user_meta.mktDuplicateResolution;
                    this.next();
                } else {
                    this.isBusy = false;
                }
            }
        }, (error) => {
            this.commonUtilService.showToastWithError(error);
        });
    }
    export() {
        const toBeExported = this.contacts.map((contact) => {
            if (typeof contact === 'object') {
                return contact.matchId;
            } else {
                return contact;
            }
        });
        // Skip all duplicates
        if (this.duplicateResolution === 'skip') {
            for (const key in this.duplicateMatchIds) {
                if (this.duplicateMatchIds.hasOwnProperty(key)) {
                    this.commonUtilService.removeMatchId(toBeExported, this.duplicateMatchIds[key]);
                }
            }
        }
        if (toBeExported.length === 0) {
            this.currentPage = this.pages.exportEmpty;
            this.showPreviousButton = false;
            this.isBusy = false;
            this.executeCurrentStep();
            return;
        }
        this.isBusy = true;
        // this.busyLabel = 'Exporting ...';
        this.busyLabel = '';
        this.busySublabel = 'Exporting your data, this will take just a minute...';
        this.exportedContactCount = toBeExported.length;
        this.marketoApiService.export(this.duplicateResolution, this.batchId, toBeExported, this.partitionName).pipe(untilDestroyed(this)).subscribe((response) => {
            this.requestBodyService.changeRevealMatchesID({ 'type': 'marketo', 'data': toBeExported });
            this.isBusy = false;
            this.next();
        }, (error) => {
            const errMsg = getErrorMessage(error, true);
            if (errMsg) {
                this.exportError = errMsg;
            } else {
                this.exportError = this.commonUtilService.setRevealError(error.status, error.message);
            }

            this.currentPage = this.pages.exportFailed;
            this.isBusy = false;
        });
    }
    close() {
        this.matDialogRef.close();
    }
    previous() {
        let page = this.currentPage - 1;
        if (this.currentPage === this.pages.exportEmpty) {
            if (this.user.user_meta.mktDuplicateResolution === 'prompt' || this.user.user_meta.mktPromptForLeadPartitions !== '1') {
                page = this.pages.duplicates;
            } else if (this.user.user_meta.mktPromptForLeadPartitions === '1' && this.user.user_meta.mktDuplicateResolution !== 'prompt') {
                page = this.pages.leadPartition;
            }
            this.showCloseButton = true;
        } else if (page === this.pages.leadPartition) {
            if (this.user.user_meta.mktDuplicateResolution !== 'prompt' || this.user.user_meta.mktPromptForLeadPartitions !== '1') {
                page = this.pages.duplicates;
                this.validateDuplicates();
            }
        }
        this.currentPage = page;
        this.executeCurrentStep();
    }
}
